import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import "./videoWithEndImage.scss";
import { useMediaQuery } from "@mui/material";
import authStore from "store/authStore";
import cartStore from "store/cartStore";
import { useNavigate } from "react-router-dom";
import ReactPixel from "react-facebook-pixel";
import { ENV } from "constant";
import { LoadingButton } from "@mui/lab";
import { useNavHeight } from "hooks/useNavHeight";
import fitty from "fitty";
import imageLoadStore from "store/imageLoadStore";

function VideoWithEndImageNew({
  websiteVideoWEBM,
  mobileVideoWEBM,
  product,
  slogan = "",
}) {
  const navigate = useNavigate();
  const navHeight = useNavHeight();

  const isMobile = useMediaQuery("(max-width: 600px)");
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const sloganRef = useRef(null);
  const buttonRef = useRef(null);
  const blurRef = useRef(null);
  const videoWebsiteRef = useRef(null);
  const videoMobileRef = useRef(null);
  const [videoHeight, setVideoHeight] = useState(null);
  const [isVisible, setIsVisible] = useState(true);

  const AuthStore = authStore();
  const CartStore = cartStore();
  const ImageLoadStore = imageLoadStore();
  const [isAddToCart, setIsAddToCart] = useState(false);
  const [isAddToCartLoading, setIsAddToCartLoading] = useState(false);

  useEffect(() => {
    fitty(titleRef.current);
  }, [product]);

  useEffect(() => {
    fitty(sloganRef.current);
  }, [slogan]);

  useEffect(() => {
    if (videoWebsiteRef.current && !isMobile) {
      setVideoHeight(videoWebsiteRef.current.clientHeight);
    }
    if (videoMobileRef.current && isMobile) {
      setVideoHeight(videoMobileRef.current.clientHeight);
    }
  }, [sectionRef, isMobile]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.3, // 30% visible = true
      },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  const handleVideoEnd = () => {
    gsap.fromTo(
      titleRef.current,
      { y: -120, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 2,
        ease: "power4.out",
      },
    );
    gsap.fromTo(
      sloganRef.current,
      { y: 120, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 2,
        ease: "power4.out",
      },
    );
    gsap.fromTo(
      buttonRef.current,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 2,
        ease: "power4.out",
      },
    );
    gsap.fromTo(
      blurRef.current,
      { background: "transparent", backdropFilter: "blur(0px)" },
      {
        background: "rgba(66, 66, 69, 0.25)",
        backdropFilter: "blur(20px)",
        duration: 1.2,
        ease: "power3.out",
      },
    );
    setVideoHeight(sectionRef.current.clientHeight);
  };

  useEffect(() => {
    if (CartStore.cartProduct && product) {
      setIsAddToCart(false);
      const isCart = CartStore.cartProduct.find(
        (item) => item.productID === product._id,
      );
      if (isCart) {
        setIsAddToCart(true);
      }
    }
  }, [CartStore.cartProduct && CartStore.cartProduct.length, product]);

  const AddToCart = async () => {
    if (AuthStore.isLogged) {
      setIsAddToCartLoading(true);
      await CartStore.signInAdd({
        productID: product._id,
        selectedColor: [],
        selectedSize: [],
      });
      setIsAddToCartLoading(false);
    } else {
      await CartStore.noSignInAdd({
        productID: product._id,
        selectedColor: [],
        selectedSize: [],
      });
    }

    if (ENV === "production") {
      ReactPixel.track("AddToCart", {
        content_ids: [product._id],
        content_name: product.productName,
        value: product.salePrice ? product.salePrice : product.regularPrice,
        currency: "INR",
      });
    }
    navigate("/checkout");
  };

  return (
    <>
      <div
        ref={sectionRef}
        className="video-with-end-image"
        // style={{
        //   minHeight:
        //     videoHeight > 150
        //       ? `${isMobile ? videoHeight - 80 : videoHeight}px`
        //       : "100vh",
        // }}
      >
        <p ref={titleRef} className="product-title">
          {product?.productName}
        </p>

        <div className="video-container">
          <video
            ref={videoMobileRef}
            width="100%"
            height="100%"
            preload="auto"
            autoPlay
            muted
            playsInline
            onEnded={handleVideoEnd}
            className="mobile"
            onLoadedData={() => {
              ImageLoadStore.setImageLoading(false);
              document.body.style.overflowY = "scroll";
              setVideoHeight(sectionRef.current.clientHeight - 120);
            }}
          >
            <source src={mobileVideoWEBM} type="video/webm" />
          </video>
          <video
            ref={videoWebsiteRef}
            width="100%"
            height="100%"
            autoPlay
            preload="auto"
            muted
            playsInline
            onEnded={handleVideoEnd}
            className="website"
            onLoadedData={() => {
              ImageLoadStore.setImageLoading(false);
              document.body.style.overflowY = "scroll";
              setVideoHeight(sectionRef.current.clientHeight);
            }}
          >
            <source src={websiteVideoWEBM} type="video/webm" />
          </video>
        </div>

        <div
          style={{
            height:
              videoHeight > 0
                ? window.innerHeight * 0.8 < videoHeight
                  ? "80vh"
                  : `${videoHeight - 80}px`
                : "80vh",
          }}
          className="btn-container"
        >
          <div className="marquee-detail typography-marquee-detail">
            <div ref={blurRef} className="glass-bg"></div>
            <div ref={buttonRef} className="detail-inner-group">
              <div
                className="marquee-pricing"
                data-pricing-hide-all="ocean-bay"
              >
                <p
                  data-pricing-hide="ocean-bay"
                  className="ric-dynamic-pricing pricing-product has-dynamic-content"
                >
                  <span data-pricing-product="ocean-bay">
                    ₹{" "}
                    {Math.round(
                      product?.salePrice || product?.regularPrice,
                    ).toFixed(2)}
                  </span>
                </p>
              </div>
              <LoadingButton
                loading={isAddToCartLoading}
                onClick={
                  isAddToCart
                    ? () => {
                        navigate("/checkout");
                      }
                    : AddToCart
                }
                className="btn btn-buy"
              >
                Buy
              </LoadingButton>
            </div>
          </div>
        </div>

        <div className="slogan" ref={sloganRef}>
          {slogan}
        </div>
      </div>
      <div
        className="buy-top-bar"
        style={{
          top: navHeight,
          opacity: isVisible ? 0 : 1,
        }}
      >
        <div className="product-name">{product?.productName}</div>
        <div className="product-buy">
          <div className="price">
            ₹{" "}
            {Math.round(product?.salePrice || product?.regularPrice).toFixed(2)}
          </div>
          <LoadingButton
            loading={isAddToCartLoading}
            onClick={
              isAddToCart
                ? () => {
                    navigate("/checkout");
                  }
                : AddToCart
            }
            className="btn btn-buy"
          >
            Buy
          </LoadingButton>
        </div>
      </div>
    </>
  );
}

export default VideoWithEndImageNew;
